<!-- BEGIN login -->
<div class="login">
    <!-- BEGIN login-content -->
    <div class="login-content">
        <div class="text-center">
            <div class="login-logo account-small-logo"></div>
        </div>
<br/>
<br/>
<br/>
<br/>
        <form>
            <h1 class="text-center">Unauthorised Access</h1>
            <div class="text text-opacity-50 text-center mb-4 mt-4">
                It appears you don't have permission to log in. 
            </div>
            <div class="text text-opacity-50 text-center mb-4">
                Please contact your Systems Administrator to make sure you have the correct role assigned to your account.
            </div>
            <button type="submit" (click)="loginAzure()" class="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3">Login with Azure</button>
            <button type="submit" (click)="logout()" class="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3" *ngIf="azureAuthService.isAuthenticated()">Logout</button>
            <button type="submit" (click)="logout()" class="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3" *ngIf="!azureAuthService.isAuthenticated()">Force Logout</button>
        </form>
    </div>
    <!-- END login-content -->
</div>
<!-- END login -->
